import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";
import Button from "@mui/material/Button";

const uiFont = appThemeFonts.family.ui;

export const CustomerAccessEditorContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 0,
  fontFamily: uiFont,
});

export const CustomerAccessEditorHeader = styled(Stack)({
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 12,
});

export const CustomerAccessHeaderText = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 6,
  minWidth: 0,
  flex: 1,
});

export const CustomerAccessHeading = styled(Typography)({
  fontFamily: uiFont,
  fontWeight: 600,
  fontSize: "13px",
  color: appThemeColors.text.heading,
  margin: 0,
  lineHeight: 1.3,
});

export const CustomerAccessDescription = styled(Typography)({
  margin: 0,
  fontFamily: uiFont,
  fontSize: "12.5px",
  color: appThemeColors.text.muted,
  lineHeight: 1.45,
});

export const CustomerAccessError = styled(Typography)({
  margin: 0,
  fontFamily: uiFont,
  fontSize: "12.5px",
  fontWeight: 500,
  color: appThemeColors.semantic.danger,
  lineHeight: 1.45,
});

export const AddCustomerButton = styled(Button)({
  alignSelf: "center",
  padding: "0",
  color: appThemeColors.text.lightBlue,
  fontSize: "12.5px",
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: uiFont,
  textTransform: "none",
  textDecoration: 'underline',
  "&:hover": {
    backgroundColor: appThemeColors.background.kbd,
  },
  "&:disabled": {
    cursor: "not-allowed",
    color: appThemeColors.text.faintLight,
  },
});

export const CustomerAccessBorderedPanel = styled(Box)({
  border: `1px solid ${appThemeColors.border.default}`,
  borderRadius: 14,
  overflow: "hidden",
  backgroundColor: appThemeColors.background.paper,
});

export const CustomerAccessColumnHeaderRow = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
  flexShrink: 0,
  gap: 16,
  padding: "8px 14px",
  backgroundColor: appThemeColors.background.paper2,
  borderBottom: `1px solid ${appThemeColors.background.soft}`,
});

export const CUSTOMER_ACCESS_CUSTOMER_COLUMN_WIDTH = 190;

export const CustomerAccessColumnHeaderLabel = styled(Typography)({
  fontFamily: uiFont,
  fontWeight: 600,
  fontSize: 11,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: appThemeColors.text.faint,
});

export const CustomerAccessCustomerHeaderCell = styled(Box)({
  flex: `0 0 ${CUSTOMER_ACCESS_CUSTOMER_COLUMN_WIDTH}px`,
  maxWidth: CUSTOMER_ACCESS_CUSTOMER_COLUMN_WIDTH,
  minWidth: 128,
});

export const CustomerAccessRolesHeaderCell = styled(Box)({
  flex: "1 1 0",
  minWidth: 0,
});

export const CustomerAccessRemoveHeaderCell = styled(Box)({
  flexShrink: 0,
  width: 88,
  textAlign: "right",
});

export const ACCESS_STATUS_COLUMN_MIN_WIDTH = 110;

export const CustomerAccessStatusHeaderCell = styled(Box)({
  flex: "0 0 auto",
  minWidth: ACCESS_STATUS_COLUMN_MIN_WIDTH,
  width: ACCESS_STATUS_COLUMN_MIN_WIDTH,
});

export const CustomerAccessRows = styled(Stack)({
  gap: 0,
  paddingBottom: 4,
});

export const CustomerAccessRow = styled(Box)({
  padding: "10px 14px 8px",
  borderBottom: `1px solid ${appThemeColors.background.soft}`,
  "&:last-of-type": {
    borderBottom: 0,
  },
});

export const CustomerAccessRowInner = styled(Stack)({
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 16,
});

export const CustomerAccessCustomerFieldCell = styled(Box)({
  flex: `0 0 ${CUSTOMER_ACCESS_CUSTOMER_COLUMN_WIDTH}px`,
  maxWidth: CUSTOMER_ACCESS_CUSTOMER_COLUMN_WIDTH,
  minWidth: 128,
  alignSelf: "flex-start",
  overflow: "visible",
  "& > *": {
    width: "100%",
    overflow: "visible",
  },
});

export const CustomerAccessRolesFieldCell = styled(Box)({
  flex: "1 1 0",
  minWidth: 0,
  alignSelf: "flex-start",
  overflow: "visible",
  "& > *": {
    width: "100%",
    overflow: "visible",
  },
});

export const CustomerAccessAccessStatusCell = styled(Box)({
  flexShrink: 0,
  width: ACCESS_STATUS_COLUMN_MIN_WIDTH,
  minWidth: ACCESS_STATUS_COLUMN_MIN_WIDTH,
  display: "flex",
  alignItems: "center",
  minHeight: 32,
});

export const CustomerAccessRemoveCell = styled(Box)({
  flexShrink: 0,
  width: 88,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  alignSelf: "flex-start",
  minHeight: 32,
});

export const CustomerAccessRemoveIconButton = styled(IconButton)({
  padding: 4,
  color: appThemeColors.text.muted,
  "&:hover": {
    backgroundColor: appThemeColors.background.kbd,
    color: appThemeColors.text.heading,
  },
});

export const CustomerAccessDeactivatedWarning = styled(Typography)({
  marginTop: 4,
  color: appThemeColors.status.warn.color,
  fontSize: 12,
  fontFamily: uiFont,
});
